export enum ProjectTypes {
  PROFILE_LOGOUT = 'profile_logout',
  PROFILE_SUCCESS = 'profile_success',
  PROFILE_ERROR = 'profile_error',
  PROFILE_REQUEST = 'profile_request',
}

export interface IProfileState {
  isProfileInit: boolean
  profileRequest: boolean
  profileError: string
  profileData: object
}

interface IProfileLogoutAction {
  type: typeof ProjectTypes.PROFILE_LOGOUT
}

interface IProfileSuccessAction {
  type: typeof ProjectTypes.PROFILE_SUCCESS
  profileData: object
}

interface IProfileErrorAction {
  type: typeof ProjectTypes.PROFILE_ERROR
  profileError: string
}

interface IProfileRequestAction {
  type: typeof ProjectTypes.PROFILE_REQUEST
}

export type ProfileActionTypes = IProfileLogoutAction | IProfileSuccessAction | IProfileErrorAction | IProfileRequestAction
export type ProfileState = IProfileState

export const initialState: ProfileState = {
  isProfileInit: false,
  profileRequest: false,
  profileError: null,
  profileData: null
}

export const profileReducer = (initialState: ProfileState, action: ProfileActionTypes): ProfileState => {
  switch (action.type) {
    case ProjectTypes.PROFILE_REQUEST:
      return {
        ...initialState, profileRequest: true, profileError: null
      }
    case ProjectTypes.PROFILE_ERROR:
      return {
        ...initialState, isProfileInit: true, profileRequest: false, profileError: action.profileError, profileData: null
      }
    case ProjectTypes.PROFILE_SUCCESS:
      return {
        ...initialState, isProfileInit: true, profileRequest: false, profileError: null, profileData: action.profileData
      }
    case ProjectTypes.PROFILE_LOGOUT:
      return {
        ...initialState, profileError: null, profileData: null
      }
    default:
      return initialState
  }
}
